import React, { ReactNode } from "react";
import { Image } from "react-bootstrap";
import Typography from "../../../../../../components/typography/Typography";

type PropType = {
  selected: boolean;
  imgSrc: string;
  thumbLabel?: string;
  groupLabels?: { type: string; name: string };
  showGroupDivider?: boolean;
  onClick: () => void;
  overlayProp: ReactNode;
};

export const CarouselThumb = React.forwardRef<HTMLDivElement, PropType>(
  (
    {
      selected,
      imgSrc,
      overlayProp,
      onClick,
      thumbLabel,
      groupLabels,
      showGroupDivider
    },
    ref
  ) => (
    <>
      {showGroupDivider && (
        <div
          data-testid="screenshots-group-divider"
          className="embla-thumbs__group-divider"
        ></div>
      )}
      <div
        ref={ref}
        className={"embla-thumbs__slide".concat(
          selected ? " embla-thumbs__slide--selected" : ""
        )}
      >
        <span onClick={onClick} className="embla-thumbs__slide__button">
          {!!groupLabels && (
            <>
              <Typography
                tag="span"
                variant="subtitle4"
                className="embla-thumbs__group-type"
                data-testid="screenshots-group-type"
              >{`${groupLabels.type}:\n`}</Typography>
              <Typography
                tag="span"
                variant="body1"
                className="embla-thumbs__group-name"
                data-testid="screenshots-group-name"
              >{`${groupLabels.name}`}</Typography>
            </>
          )}
          <div className="rl-cloud-sandbox__screenshots-autoplay">
            <Image
              thumbnail
              className="embla-thumbs__slide__img"
              src={imgSrc}
              alt=""
            />
            {overlayProp}
          </div>
          <span>{thumbLabel}</span>
        </span>
      </div>
    </>
  )
);
